// Tool categories data for the Tools tab
export const toolCategories = [
  {
    title: "General AI Assistance",
    description: "These tools offer broad capabilities for answering questions, generating text, brainstorming, and performing various knowledge-based tasks.",
    transitionDelay: 0, // No delay for first category
    tools: [
      {
        name: "Abacus",
        description: "An AI platform providing access to multiple large language models, document analysis, and code generation tools, often geared towards business applications and model comparison.",
        referralLink: "https://chatllm.abacus.ai/FkqJQgSHHk",
        referralText: "Referral link →",
        highlight: true
      },
      {
        name: "Perplexity",
        description: "A conversational AI search engine that provides summarized answers with citations drawn directly from web sources, focusing on up-to-date information retrieval."
      },
      {
        name: "ChatGPT",
        description: "A highly versatile conversational AI from OpenAI, capable of generating human-like text, answering questions, writing code, translating languages, and assisting with creative and analytical tasks."
      },
      {
        name: "Claude",
        description: "A conversational AI assistant developed by Anthropic, emphasizing safety, ethical interactions, and strong capabilities in handling long documents, complex reasoning, and creative writing."
      },
      {
        name: "Google AI Studio",
        description: "A web-based platform for quickly building and testing LLM-powered apps, offering an easy interface for prompt creation and prototyping AI features."
      }
    ]
  },
  {
    title: "AI Extensions",
    description: "Browser extensions and add-ons that enhance your AI experience and productivity across websites.",
    transitionDelay: 0.1, // Between General AI (0) and No-Code (0.2)
    tools: [
      {
        name: "Go Full Page",
        description: "A browser extension that captures entire webpage screenshots, allowing you to easily save and share full page content with AI assistants for analysis or reference.",
        referralLink: "https://gofullpage.com/",
        referralText: "Visit website →"
      },
      {
        name: "TextBlaze",
        description: "Productivity extension that lets you create custom templates and snippets to automate repetitive typing tasks. Integrates with AI workflows to streamline text input and generation.",
        referralLink: "https://blaze.today/",
        referralText: "Visit website →"
      },
      {
        name: "Superwhisper",
        description: "AI-powered voice-to-text tool that works with any app, letting you dictate instead of type.\n",
        referralLink: "https://superwhisper.com/",
        referralText: "Visit website →"
      }
    ]
  },
  {
    title: "No-Code / Low-Code Web App Development",
    description: "These tools leverage AI to help users build websites or web application interfaces, often with minimal or no traditional coding required.",
    transitionDelay: 0.2,
    tools: [
      {
        name: "Lovable",
        description: "An AI platform specializing in generating unique website designs and layouts based on user prompts and requirements, focusing on the visual and structural aspects."
      },
      {
        name: "v0",
        description: "An AI tool by Vercel that generates front-end UI code (like React with Tailwind CSS) from text descriptions or image references, accelerating interface development."
      },
      {
        name: "Replit",
        description: "A browser-based coding environment that includes AI assistance (like Ghostwriter) and features facilitating rapid development and deployment, suitable for prototyping and building web apps."
      },
      {
        name: "Bolt.new",
        description: "An AI-powered website generator, often associated with Framer, that creates initial site designs, layouts, and copy from simple text prompts."
      }
    ]
  },
  {
    title: "Marketing & Design",
    description: "This category includes AI tools focused on creating visual content, marketing copy, and design elements.",
    transitionDelay: 0.3,
    tools: [
      {
        name: "ChatGPT",
        description: "A versatile AI assistant from OpenAI useful for generating marketing copy, brainstorming campaign ideas, writing product descriptions, and creating text-based content for designs."
      },
      {
        name: "Canva",
        description: "An accessible online design platform featuring AI tools (\"Magic Studio\") to simplify and accelerate the creation of graphics, presentations, social media posts, videos, and other visual marketing materials."
      },
      {
        name: "Midjourney",
        description: "An AI image generation tool accessed via Discord, renowned for producing highly artistic and stylized visuals from text descriptions, popular for unique branding and creative assets."
      },
      {
        name: "Luma AI",
        description: "An AI platform specializing in generating 3D models, scenes (NeRFs), and video effects from text prompts or existing video footage, useful for product showcases and immersive content."
      }
    ]
  },
  {
    title: "Voice & Audio AI",
    description: "Tools focused on processing, generating, or interacting with voice and audio data.",
    transitionDelay: 0.4,
    tools: [
      {
        name: "Grok voice",
        description: "The conversational AI model from xAI, known for its integration with real-time information (like from X/Twitter) and sometimes characterized by a distinct, potentially edgy, personality."
      },
      {
        name: "ChatGPT Advanced Voice",
        description: "The enhanced, more natural-sounding voice conversation feature available in paid tiers of ChatGPT, allowing for real-time spoken interaction with the AI."
      },
      {
        name: "Sesame",
        description: "An AI tool focused on transcribing, summarizing, and analyzing voice conversations from meetings or calls to extract key information and action items."
      }
    ]
  },
  {
    title: "Automation and Development",
    description: "Tools that help automate workflows and enhance development processes.",
    transitionDelay: 0.6,
    tools: [
      {
        name: "Zapier",
        description: "A popular online automation tool that connects thousands of web apps, allowing users to create automated workflows (called \"Zaps\") between them without needing to write code."
      },
      {
        name: "Cursor.AI",
        description: "A code editor specifically designed for pair programming with AI, integrating features like code generation, editing, and debugging directly within the development environment."
      },
      {
        name: "Windsurf",
        description: "An open-source platform for developers to build internal tools, workflows, and scripts quickly using Python, Typescript, Go, SQL, and low-code interfaces."
      },
      {
        name: "Manus AI",
        description: "A next-generation autonomous AI agent that automates complex workflows, executes real-world tasks, and integrates with external tools for business process automation, data analysis, and software development.",
      }
    ]
  }
]; 